// Module
var code = "<a class=\"be-indicator\" href=\"{{ $ctrl.url }}\" target=\"_blank\" rel=\"noopener\" ng-if=\"$ctrl.limitedToBE\">\n  <ng-transclude></ng-transclude>\n  <pr-icon icon=\"'briefcase'\" class-name=\"'space-right be-indicator-icon'\"></pr-icon>\n  <span class=\"be-indicator-label\">Business Edition Feature</span>\n</a>\n";
// Exports
var _module_exports = code;;
var path = 'app/portainer/components/BEFeatureIndicator/BEFeatureIndicator.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;